<template>
    <div class="menu">
        <nav class="menu__content" v-bind:class="{'is-open': showMobileMenu}">
            <router-view name="menu"></router-view>
        </nav>

        <div class="menu__scrim"></div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import TheHeader from '@/components/general/TheHeader';
    import TheFooter from '@/components/general/TheFooter';
    import Sidebar from '@/components/general/Sidebar';
    import vMediaQuery from 'v-media-query';

    import firebase from 'firebase';

    @Component({
//        watch: {
//            '$mq.resize': 'hideMobileMenu',
//
//            showMobileMenu: function(newVal) {
//                const className = 'nav__mobile_open';
//                if (newVal) {
//                    document.body.classList.add(className);
//                } else {
//                    document.body.classList.remove(className);
//                }
//            }
//        }
    })
    export default class MenuDrawer extends Vue {
        name = 'menu-drawer';

        showMobileMenu = false;

        logout() {
//            firebase.auth().signOut();
        }

        toggleMobileMenu() {
            if (this.$mq.below(768)) {
                this.showMobileMenu = !this.showMobileMenu;
            } else {
                this.showMobileMenu = false;
            }

            console.log('Toggle menu', this.showMobileMenu);
        }
    }

    Vue.component('menu-drawer', MenuDrawer);
</script>

<style src="./styles.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/general/menu/Menu.vue